










































import { Mixins, Component, Inject } from "vue-property-decorator";
import { IContractProductProvider } from "@/models/providers/contractProduct";
import Context from "@/mixins/context";
import CProdMixin from "@/mixins/cProdMixin";

@Component
export default class CProdInherentlyLinkedMsg extends Mixins(
  Context,
  CProdMixin
) {
  // Inject

  @Inject({ from: "contractProductProvider" })
  public readonly $cProdData!: () => IContractProductProvider;

  // Computed

  public get cProdData() {
    return this.$cProdData();
  }

  public get isVisible() {
    if (!this.cProdData.siblingSubscriptions.length) return false;
    return ["clientCProdSettings", "adminClientCProdSettings"].includes(
      this.$route.name as string
    );
  }
}
